import { AfterViewInit, Component, Input, ViewChild, ViewContainerRef } from '@angular/core';
import {
  WagtailPageContentElementInterface,
  WagtailTwoColumnsRendererInterface
} from "@gea-waldviertler-website/gea-models";
import { WagtailContentRendererFactory } from "../../factory.content-renderer";

@Component({
    selector: 'wagtail-page-element-two-columns',
    templateUrl: './two-columns.component.html',
    styleUrls: ['./two-columns.component.scss'],
    standalone: false
})
export class WagtailTwoColumnsComponent implements AfterViewInit {
  @Input() definition?: WagtailPageContentElementInterface<WagtailTwoColumnsRendererInterface>
  @ViewChild('firstColumn', { read: ViewContainerRef }) public firstColumn?: ViewContainerRef
  @ViewChild('secondColumn', { read: ViewContainerRef }) public secondColumn?: ViewContainerRef

  //@ViewChild('templateRef', { read: TemplateRef, static: true }) templateRef!: TemplateRef<any>

  firstColumnClassNames?: string
  secondColumnClassNames?: string

  ngAfterViewInit(): void {
    if (! this.definition) return

    for (const ce of this.definition.value.first_column) {
      WagtailContentRendererFactory.renderContentElement(this.firstColumn, ce)
    }
    for (const ce of this.definition.value.second_column) {
      WagtailContentRendererFactory.renderContentElement(this.secondColumn, ce)
    }

    let colWidths = this.definition.value.verteilung.split('-')

    if (colWidths.length == 2) {
      this.firstColumnClassNames = 'col-xs-12 col-md-' + colWidths[0]
      this.secondColumnClassNames = 'col-xs-12 col-md-' + colWidths[1]
    }
  }
}
